<div class="mt-progress mb-2">
  <div class="mt-percentage">{{ value }}%</div>
  <mat-progress-bar mode="determinate" [value]="value"></mat-progress-bar>
</div>
